// Canonical light-theme roles from the Outdoorlink UI Style Guide.
//
// Keep these values centralized: palette generation, CSS custom properties,
// and MUI's JS palette all consume this contract. Components should use the
// semantic CSS variables or MUI palette instead of importing this module.
export const ODL_STYLE_GUIDE = Object.freeze({
  primary: Object.freeze({
    main: '#0050A3',
    light: '#E7F0FF',
    dark: '#033668',
    onMain: '#FFFFFF',
  }),
  success: Object.freeze({
    main: '#16A34A',
    light: '#ECFDF5',
  }),
  status: Object.freeze({
    active: '#16A34A',
    warning: '#F59E0B',
    critical: '#DC2626',
    maintenance: '#7C3AED',
  }),
  neutral: Object.freeze({
    background: '#F8FAFC',
    surface: '#FFFFFF',
    border: '#E7EAF0',
    divider: '#EEF2F6',
    textPrimary: '#0F172A',
    textSecondary: '#64748B',
    textMuted: '#94A3BB',
  }),
  interactive: Object.freeze({
    hover: '#F1F5F9',
    selected: '#EFF6FF',
    focusRing: '#CCE0FF',
    link: '#0050A3',
    linkHover: '#033668',
    disabled: '#CBD5E1',
  }),
  typography: Object.freeze({
    family: 'Inter Variable',
  }),
  icon: Object.freeze({
    size: 24,
    strokeWidth: 2,
  }),
});
